export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [5, 10, 20, 50];

export enum MasterConfigCategory {
  ALL_CONFIGS = "ALL_CONFIGS",
  DEPARTMENT = "department",
  DESIGNATION = "designation",
  EMPLOYMENT_TYPE = "employment_type",
  EMPLOYMENT_DISCIPLINE = "employment_discipline",
  RELATIONSHIP = "relationship",
  EMPLOYMENT_STATUS = "employment_status",
  GENDER = "gender",
  TIMESHEET_STATUS = "timesheet_status",
  ORGANIZATION_STATUS = "organization_status",
  GAME_TYPE = "game_type",
  DOCUMENT_TYPE = "document_type",
  NOTICE_PERIOD = "notice_period"
}
